// Routes that don't require authentication
const PUBLIC_ROUTES = [
  'auth-login',
  'auth-forget-password',
  'auth-reset-password',
  'auth-activate-account'
]

export default function ({ store, route, redirect, error }) {
  const isPublic = PUBLIC_ROUTES.some(name => route.name?.startsWith(name))
  if (isPublic) {
    return
  }

  if (!store.getters['authProfile/isLoggedIn']) {
    return redirect('/auth/login')
  }

  // Per-route permission check.
  // Pages declare:   permission: ['indexX', 'storeX', 'updateX', 'destroyX']
  // (a single string or array of permission names — same shape as $hasPermission)
  const permission = route.meta?.length ? route.meta[0].permission : null

  console.log('Required permission for this route:', permission)

  if (permission && !store.getters['authProfile/hasPermission'](permission)) {
    return error({
      statusCode: 403,
      message: 'ليس لديك صلاحية للوصول إلى هذه الصفحة'
    })
  }
}
